module.exports = __webpack_public_path__ + "static/img/配送.7636a39a.png";